import { render, staticRenderFns } from "./news.vue?vue&type=template&id=7d4cafd4&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4cafd4')) {
      api.createRecord('7d4cafd4', component.options)
    } else {
      api.reload('7d4cafd4', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=7d4cafd4&", function () {
      api.rerender('7d4cafd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/top/news.vue"
export default component.exports